// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import propTypes from 'prop-types';

import { MrCountTableTitle } from '@ion/components';

export const PipelineIntegrationsTableCountTitle = ({ tableData }) => {
  const count = tableData.length;

  const countTableTitleProps = {
    title: {
      singular: 'Integration',
      plural: 'Integrations',
    },
    count,
  };

  return <MrCountTableTitle {...countTableTitleProps} />;
};

PipelineIntegrationsTableCountTitle.propTypes = {
  tableData: propTypes.array,
};
